import { AcademicTitleId, ActivityTypeCollection, ActivityTypeId, CurrentAcademicUser, Option } from ".";

export class ActivityCategory {
	constructor(
		public readonly id: number,
		public readonly label: string,
		public readonly activityTypes: ActivityTypeCollection
	) { }

	public static createForAcademicUserOption(types: ActivityTypeCollection, user: Option<CurrentAcademicUser>): ActivityCategory[] {
		const isAcademicCoordinator = user?.value?.academic?.title?.id === AcademicTitleId.AcademicCoordinator;
		const categories = this.create(types);

		if (!isAcademicCoordinator)
			return categories.filter(cat => cat.id !== ActivityCategoryId.AcademicCoordinationCategory);
		
		return categories;
	}
	
	public static create(types: ActivityTypeCollection): ActivityCategory[] {
		function cat(id: ActivityCategoryId, definitions): ActivityCategory {
			var pairs = definitions 
			.map(p => ({type: types.getTypeById(p.id), label: p.label}));
			return new ActivityCategory(
				id,
				pairs.map(p => p.label).join(''),
				new ActivityTypeCollection(pairs.map(p => p.type)));
		}
		return [
			cat(ActivityCategoryId.ExtensionEffortResearchCreativeCategory, [
				{id: ActivityTypeId.Extension,                  label: 'Extension, '},
				{id: ActivityTypeId.Outreach,                   label: 'Effort, '},
				{id: ActivityTypeId.ExtensionAndOrOutreach,     label: ''},
				{id: ActivityTypeId.Other,                      label: ''},
				{id: ActivityTypeId.AppliedResearchAndCreative, label: 'Research, Creative'}
			]),
			cat(ActivityCategoryId.UniversityPublicServiceCategory, [
				{id: ActivityTypeId.UniversityAndPublicService, label: 'University and Public Service'}
			]),
			cat(ActivityCategoryId.ProfessionalCompetenceCategory, [
				{id: ActivityTypeId.ProfessionalCompetence,     label: 'Professional Competence'}
			]),
			cat(ActivityCategoryId.AcademicCoordinationCategory, [
				{id: ActivityTypeId.AcademicCoordination,       label: 'Academic Coordination'}
			])
		];
	}
}

export enum ActivityCategoryId 
{
	ExtensionEffortResearchCreativeCategory = 0,
	UniversityPublicServiceCategory = 1,
	ProfessionalCompetenceCategory = 2,
	AcademicCoordinationCategory = 3
}
